import { fmtBRL } from "@/lib/api";
import { Server } from "lucide-react";

export const MastersTable = ({ masters, onPick, current }) => (
  <div data-testid="table-contas-master" className="lg:col-span-5 rounded-2xl border border-[#1F293D] bg-[#111827] p-5 fade-up" style={{ animationDelay: "240ms" }}>
    <h3 className="mb-4 flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-slate-200">
      <Server className="h-4 w-4 text-violet-400" /> Contas master
      <span className="ml-auto hidden text-[10px] font-normal normal-case tracking-normal text-slate-500 sm:inline">ativos · previsto semana · WhatsApp · créditos</span>
    </h3>
    <div className="space-y-2">
      {masters.map((m) => (
        <button key={m.account} data-testid={`master-row-${m.account}`} onClick={() => onPick(current === m.account ? "" : m.account)}
          className={`w-full rounded-xl border p-3 text-left transition-colors ${current === m.account ? "border-sky-500/60 bg-sky-500/5" : "border-[#1F293D] bg-[#0F141F] hover:border-[#334155]"}`}>
          <div className="flex items-center justify-between">
            <span className="font-mono text-sm font-semibold text-sky-300">{m.account}</span>
            <span className="font-mono text-sm font-bold text-emerald-300">{fmtBRL(m.mrr)}<span className="text-[10px] font-normal text-slate-500">/mês</span></span>
          </div>
          <div className="mt-1.5 grid grid-cols-2 gap-x-2 gap-y-1 font-mono text-[11px] text-slate-400 sm:grid-cols-4">
            <span><b className="text-slate-200">{m.active}</b> ativos</span>
            <span title="Previsto na semana"><b className="text-slate-200">{fmtBRL(m.week)}</b></span>
            <span><b className="text-slate-200">{m.wa_pct}%</b> WhatsApp</span>
            <span><b className="text-slate-200">{m.credits != null ? m.credits.toLocaleString("pt-BR") : "-"}</b> créd.</span>
          </div>
        </button>
      ))}
    </div>
  </div>
);
